import { render } from "./CallbackPage.vue?vue&type=template&id=6028be0a"
import script from "./CallbackPage.vue?vue&type=script&lang=js"
export * from "./CallbackPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__